import React, { Component, Fragment } from "react";

class FooterBox extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const { title, children } = this.props;
    return (
      <Fragment>
        {title && <h1 className="title has-text-light">{title}</h1>}
        {children}
      </Fragment>
    );
  }
}

export default FooterBox;



// WEBPACK FOOTER //
// ./src/presentational/FooterBox/index.js